/**
 * Temporary script to display school lookup disabled warning
 * Add this to Shopify theme editor: Assets > Add a new asset > school-lookup-warning.js
 * Then include it in theme.liquid: <script src="{{ 'school-lookup-warning.js' | asset_url }}" defer></script>
 */

(function() {
  'use strict';

  // Function to inject warning message
  function injectSchoolLookupWarning() {
    // Wait for modal to be in DOM
    const modalWrapper = document.querySelector('.cart-school-modal__wrapper');

    if (!modalWrapper) {
      return;
    }

    // Check if warning already exists
    if (document.querySelector('.cart-school-modal__service-warning')) {
      return;
    }

    // Create warning element
    const warningDiv = document.createElement('div');
    warningDiv.className = 'cart-school-modal__service-warning';
    warningDiv.style.cssText = 'background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 16px; margin: 16px 0;';

    const warningText = document.createElement('p');
    warningText.className = 'text-body-s-regular';
    warningText.style.cssText = 'color: #856404; margin: 0;';
    warningText.textContent = `We are currently experiencing issues with school checkout. In case you face checkout error. Please select "Can't find your school?" to proceed. We apologise for any inconvenience.`;

    warningDiv.appendChild(warningText);

    // Insert after the title section
    const titleSection = modalWrapper.querySelector('.cart-school-modal__title');
    if (titleSection && titleSection.nextSibling) {
      modalWrapper.insertBefore(warningDiv, titleSection.nextSibling);
    }
  }

  // Try to inject when modal opens
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        injectSchoolLookupWarning();
      }
    });
  });

  // Start observing when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
      injectSchoolLookupWarning();
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
    injectSchoolLookupWarning();
  }
})();
